export default {
  title: 'Weekly Performance',
  messages_sent: 'Messages Sent',
  messages_delivered: 'Messages Delivered',
  click_rate: 'Average Click Rate',
  awaiting: 'Awaiting confirmation',
  legend: {
    sent: 'Sent',
    clicked: 'Clicked',
    delivered: 'Delivered',
  },
  error_messages: {
    failed_to_load_data: 'Failed to load data',
  },
};
